module.exports = __webpack_public_path__ + "static/img/116.5ee8f5a.png";